import React, { useState, useEffect } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth, db } from "../../firebase";
import { doc, getDoc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import "./AdminPanel.css"; // Reuse basic styles or create specific ones

export default function AdminLogin() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    // Redirect if already logged in as admin
    useEffect(() => {
        const checkUser = async () => {
            if (auth.currentUser) {
                const userDoc = await getDoc(doc(db, "users", auth.currentUser.uid));
                if (userDoc.exists() && userDoc.data().role === 'admin') {
                    navigate('/admin/dashboard');
                }
            }
        };
        checkUser();
    }, [navigate]);

    const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError("");

        try {
            // 1. Authenticate with Firebase Auth
            const userCredential = await signInWithEmailAndPassword(auth, email, password);
            const user = userCredential.user;

            // 2. Check Role in Firestore
            const userDoc = await getDoc(doc(db, "users", user.uid));

            if (!userDoc.exists() || userDoc.data().role !== 'admin') {
                // Not an admin! Sign out immediately.
                await auth.signOut();
                setError("Access Denied: You are not authorized as an Administrator.");
            } else {
                // Success
                navigate("/admin/dashboard");
            }
        } catch (err) {
            console.error(err);
            setError("Login failed: " + err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="admin-container" style={{ justifyContent: 'center', alignItems: 'center', background: '#1a1c23' }}>
            <div className="modal-content" style={{ width: '400px', padding: '40px', borderRadius: '12px' }}>
                <h2 style={{ textAlign: 'center', marginBottom: '30px', color: '#333' }}>Admin Portal</h2>

                {error && <div className="status-badge status-blocked" style={{ marginBottom: '20px', display: 'block', textAlign: 'center' }}>{error}</div>}

                <form onSubmit={handleLogin}>
                    <div className="form-group">
                        <label>Email Address</label>
                        <input
                            type="email"
                            required
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="admin@chatiq.com"
                        />
                    </div>

                    <div className="form-group pb-4">
                        <label>Password</label>
                        <input
                            type="password"
                            required
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="••••••••"
                        />
                    </div>

                    <button
                        type="submit"
                        className="admin-btn btn-primary"
                        style={{ width: '100%', padding: '12px', fontSize: '1rem' }}
                        disabled={loading}
                    >
                        {loading ? "Verifying..." : "Login to Admin Panel"}
                    </button>
                </form>

                <div style={{ marginTop: '20px', textAlign: 'center' }}>
                    <span
                        style={{ color: '#666', fontSize: '0.9rem', cursor: 'pointer', textDecoration: 'underline' }}
                        onClick={() => navigate('/')}
                    >
                        Return to Main Site
                    </span>
                </div>
            </div>
        </div>
    );
}
